import { memo } from "react";
import { TextField, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useAppContext } from "../../../../context/appContext";

function SignUpCardFields({ fields }) {
  const theme = useTheme();
  const { isMobile } = useAppContext();

  const renderInputField = (field) => {
    if (!field) return null;

    const hasError = field.error && Object.keys(field.error).length > 0;
    const errorMessage = hasError ? Object.values(field.error)[0] : "";

    return (
      <TextField
        fullWidth
        type={field.type}
        placeholder={field.placeholder}
        name={field.name}
        value={field.value}
        onChange={field.onChange}
        autoComplete={field.autoComplete}
        error={hasError}
        helperText={errorMessage}
        variant="outlined"
        sx={{
          width: "100%",

          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
            backgroundColor: "#d7e5f8",

            "& fieldset": {
              border: "none",
            },
          },

          "& .MuiInputBase-input": {
            padding: isMobile ? "10px 10px" : "12px",
            fontSize: "0.75rem",
            color: theme.palette.text.secondary,
          },

          "& .MuiInputBase-input::placeholder": {
            color: theme.palette.text.secondary,
            opacity: 0.8,
          },

          "& input:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0 1000px #d7e5f8 inset",
            WebkitTextFillColor: theme.palette.text.secondary,
            borderRadius: "10px",
            transition: "background-color 9999s ease-in-out 0s",
          },

          "& input:-webkit-autofill:hover": {
            WebkitBoxShadow: "0 0 0 1000px #d7e5f8 inset",
          },

          "& input:-webkit-autofill:focus": {
            WebkitBoxShadow: "0 0 0 1000px #d7e5f8 inset",
          },

          "& .MuiFormHelperText-root": {
            color: theme.palette.text.red,
            marginLeft: "4px",
            marginRight: "4px",
          },
        }}
      />
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: isMobile ? 0.5 : 1,
        width: "100%",
        alignItems: "center",
      }}
    >
      {renderInputField(fields.firstName)}
      {renderInputField(fields.lastName)}
      {renderInputField(fields.email)}
      {renderInputField(fields.abbreviation)}
      {renderInputField(fields.password)}
      {renderInputField(fields.passwordConfirmation)}
    </Box>
  );
}

export default memo(SignUpCardFields);
